var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Web3 = require("web3");

var lookup = require('./lookup');

var getChainId = require('./getChainId');

function navigate() {
  return _navigate.apply(this, arguments);
}

function _navigate() {
  _navigate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref,
        rpcUrl,
        web3,
        networkId,
        networkIdHex,
        chainIdHex,
        network,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, rpcUrl = _ref.rpcUrl;
            web3 = new Web3(rpcUrl);
            _context.next = 4;
            return web3.eth.net.getId();

          case 4:
            networkId = _context.sent;
            networkIdHex = '0x' + networkId.toString(16);
            _context.next = 8;
            return getChainId(web3).catch(function () {
              console.warn('Unable to get chainId');
            });

          case 8:
            chainIdHex = _context.sent;
            network = lookup(networkIdHex, chainIdHex) || {
              networkId: networkIdHex
            };

            if (chainIdHex && !network.chainId && chainIdHex.toLowerCase() !== networkIdHex.toLowerCase()) {
              network.chainId = chainIdHex;
            }

            return _context.abrupt("return", network);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _navigate.apply(this, arguments);
}

module.exports = navigate;